import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

/**
 * Footer newsletter signup. Same closed anonymous body as the contact page's ContactService:
 * POST {formsApiUrl}/portal/forms/{newsletterFormSchemaId}/submissions with a `tenantId` header and
 * never a bearer (a token that is merely present is validated and 401s on the permit path).
 * `enabled` is false until `newsletterFormSchemaId` names a real "Newsletter signup" schema on the
 * site tenant; the footer hides the form while it is off.
 */
@Injectable({ providedIn: 'root' })
export class NewsletterService {
    constructor(private http: HttpClient) { }

    get enabled(): boolean {
        return !!(environment as any).newsletterFormSchemaId;
    }

    subscribe(email: string): Observable<unknown> {
        const env = environment as any;
        const body = {
            title: `Newsletter — ${email}`,
            description: email.slice(0, 140),
            content: JSON.stringify({ answersByLocale: { en: { email } }, displayByLocale: { en: { 'Email': email } } })
        };
        return this.http.post(`${env.formsApiUrl}/portal/forms/${env.newsletterFormSchemaId}/submissions`, body,
            { headers: new HttpHeaders({ tenantId: env.tenantId }) });
    }
}
